import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const essentialsRoutes: Routes = [
  {
    title: 'pagesTitles.essentials',
    path: APP_ROUTES.ESSENTIALS,
    canActivate: [permissionGuard(APP_PERMISSIONS.EssentialsRead)],
    loadComponent: () => import('./pages/list-essential').then((m) => m.ListEssential),
  },
  {
    title: 'pagesTitles.essentialComplete',
    path: APP_ROUTES.ESSENTIALS_COMPLETE,
    canActivate: [permissionGuard(APP_PERMISSIONS.EssentialsCreate)],
    loadComponent: () =>
      import('./pages/create-complete-essential').then((m) => m.CreateCompleteEssential),
  },
  {
    title: 'pagesTitles.essentialEdit',
    path: APP_ROUTES.ESSENTIALS_EDIT,
    canActivate: [permissionGuard(APP_PERMISSIONS.EssentialsUpdate)],
    loadComponent: () => import('./pages/update-essential').then((m) => m.UpdateEssential),
  },
  {
    title: 'pagesTitles.essentialDetail',
    path: APP_ROUTES.ESSENTIALS_DETAIL,
    canActivate: [permissionGuard(APP_PERMISSIONS.EssentialsRead)],
    loadComponent: () => import('./pages/show-essential').then((m) => m.ShowEssential),
  },
];
